{
    "LicenseManagement_Title": "UNTERNEHMENSLIZENZMANAGEMENT",
    "LicenseManagement_Heading_License": "Lizenz",
    "LicenseManagement_Heading_Quantity": "Menge",
    "LicenseManagement_Essentials": "Grundlegende Informationen",
    "LicenseManagement_Essentials_MST": "CXA-Standard",
    "LicenseManagement_Professional": "Professionell",
    "LicenseManagement_Professional_MST": "CXA-Prämie",
    "LicenseManagement_Enterprise": "Unternehmen",
    "LicenseManagement_Enterprise_MST": "CXA Fortgeschrittene",
    "LicenseManagement_CallCentreAgent": "Call-Center-Agent",
    "LicenseManagement_CallCentreAgent_MST": "CXE-Prämie",
    "LicenseManagement_CallCentreSupervisor": "Call-Center-Betreuer",
    "LicenseManagement_CallCentreSupervisor_MST": "CXE Fortgeschrittene",
    "LicenseManagement_Validation_Number": "Muss eine gültige Nummer sein",
    "LicenseManagement_Validation_Limit": "Übersteigt die CME-Lizenzobergrenze. Muss kleiner als oder gleich {} sein",
    "LicenseManagement_Validation_Limit_Reached": "Übersteigt die CME-Lizenzobergrenze. Keine Lizenzen mehr verfügbar",
    "LicenseManagement_Validation_MAX_LIMIT": "Anzahl überschreitet die maximal zulässige Anzahl",
    "LicenseManagement_Validation_POSITIVE_NUMBER": "Zahl muss positiv sein",
    "NAME": "LicenseManagement",
    "LicenseManagement_CXIntegration": "CX-Integration"
}